import React, { useState, useContext } from 'react';
import { UserContext } from '../../Contexts/UserContext';
import { logout } from '../../api/auth';

import { useNavigate, useLocation, Link } from 'react-router-dom';

//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import { Button } from '@mui/material';
import FramerateIcon from '../../assets/logo/play.png';
import AdpushupIcon from '../../assets/logo/adpushup-icon.png';
//===============

export default function Navbar() {
	const classes = useStyles();
	const location = useLocation();
	const navigate = useNavigate();
	const { user, setUser } = useContext(UserContext);

	const [anchorEl, setAnchorEl] = useState(null);
	const NODE_ENV = process.env.NODE_ENV;

	const handleMenu = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLogout = () => {
		(async function () {
			try {
				const res = await logout();
				setUser(null);
				navigate('/login');
			} catch (err) {
				console.log('Navbar.jsx Logs : ', err);
			}
		})();
	};

	const getPageTitle = () => {
		if (location.pathname.includes('banner-fp')) {
			return 'BANNER FLOOR ENGINE';
		}
		if (location.pathname.includes('splitDoc')) {
			return 'FRAMERATE SCRIPT SPLIT';
		}
		if (location.pathname.includes('fvp-editor')) {
			return 'FRAMERATE VPAID PLAYER';
		}
		return 'FRAMERATE';
	};

	const getIcon = () => {
		const adpushupIconPaths = ['banner-fp', 'splitDoc', 'fvp-editor', 'dashboard'];
		const useAdpushupIcon = adpushupIconPaths.some((path) => location.pathname.includes(path));
		if (useAdpushupIcon) {
			return (
				<img
					src={AdpushupIcon}
					style={{ width: '4rem', height: '4rem', margin: '0 2rem 0 2rem' }}
				/>
			);
		}
		return (
			<img src={FramerateIcon} style={{ width: '4rem', height: '4rem', margin: '0 2rem 0 2rem' }} />
		);
	};

	return (
		<Box
			sx={{
				position: 'fixed',
				width: '100%',
				height: '10vh',
				top: 0,
				display: 'flex',
				alignItems: 'center',
				borderBottom: '1px solid #909497',
				backgroundColor: '#fff',
				zIndex: 1,
				letterSpacing: '3px'
			}}
		>
			<Typography
				variant="h4"
				component="div"
				className={classes.gradientNavBarHeading}
				onClick={() => navigate('/dashboard')}
			>
				{getIcon()}
				{getPageTitle()}
				{NODE_ENV === 'development' ? <CurrentEnvironmentBanner /> : null}
			</Typography>
			<Box style={{ flex: '5', display: 'flex', justifyContent: 'flex-end' }}>
				{user && (
					<Box style={{ height: '100%', alignItem: 'right' }}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleMenu}
							color="inherit"
						>
							<AccountCircle fontSize="large" color="primary" style={{ height: '100%' }} />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorEl}
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'right'
							}}
							keepMounted
							transformOrigin={{
								vertical: 'top',
								horizontal: 'right'
							}}
							style={{ marginTop: '5rem' }}
							open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							<Box className={classes.anchorStyles}>
								<Box>{user.email && user.email.substring(0, user.email.indexOf('@'))}</Box>
								<Box>{user.email}</Box>
								<Box onClick={handleClose}>
									<Button variant="contained" onClick={handleLogout}>
										Logout
									</Button>
								</Box>
							</Box>
						</Menu>
					</Box>
				)}
			</Box>
		</Box>
	);
}


function CurrentEnvironmentBanner() {
	return (
		<div
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: 0,
				height: 0,
				borderTop: '9.5rem solid #0f7510',
				borderRight: '9.6rem solid transparent',
				zIndex: 10,
			}}
		>
			<span
				style={{
					position: 'absolute',
					top: '-8rem',
					left: '1rem',
					color: '#fff',
					fontWeight: 'bold',
					fontSize: '1.5rem',
					transform: 'rotate(-45deg)',
					letterSpacing: '2px',
					userSelect: 'none',
					fontFamily: 'monospace',
					textShadow: '1px 1px 4px rgba(0,0,0,0.4)',
				}}
			>
				DEV MODE
			</span>
		</div>

	);
}